import React from 'react';

import { Box } from '@hbf/dsl';
import { Coords, LoadableGoogleMap } from 'ha/modules/GoogleMap';
import { ListingMapMarker } from 'ha/components.legacy/Listing/ListingMapMarker';
import { ListingMapErrorBoundary } from 'ha/components.legacy/Listing/ListingMapErrorBoundary';

import { INITIAL_MAP_ZOOM } from '../constants';

interface Props {
  coordinates: Coords;
  dragging?: boolean;
  scrollwheel?: boolean;
  touchZoom?: boolean;
  doubleClickZoom?: boolean;
  boxZoom?: boolean;
  scrollWheelZoom?: boolean;
  tap?: boolean;
  zoomControl?: boolean;
}

export const Map: React.FC<Props> = ({
  coordinates,
  scrollwheel = false,
  dragging = true,
  touchZoom = false,
  doubleClickZoom = false,
  boxZoom = false,
  scrollWheelZoom = false,
  tap = false,
  zoomControl = true,
}) => {
  return (
    <Box height="100%" data-test-locator="FSG Map tab">
      <ListingMapErrorBoundary>
        <LoadableGoogleMap
          center={coordinates}
          options={{
            scrollwheel,
            dragging,
            touchZoom,
            doubleClickZoom,
            boxZoom,
            scrollWheelZoom,
            tap,
            zoomControl,
          }}
          zoom={INITIAL_MAP_ZOOM}
        >
          <ListingMapMarker lat={coordinates.lat} lng={coordinates.lng} />
        </LoadableGoogleMap>
      </ListingMapErrorBoundary>
    </Box>
  );
};
